import React, { useRef, useEffect } from 'react';
import styles from './exercise-iframe.module.css.js';

const ExerciseIframe = ({ exerciseUrl, medialink, onExerciseFinished }) => {
    const playerFinished = useRef(false);
    const { hostname } = new URL(exerciseUrl);
    useEffect(() => {
        const onMessage = (event) => {
            if (!hostname)
                return;
            if (!event.origin.includes(hostname))
                return;
            switch (medialink.kind) {
                case 'exercise-eduhint':
                    if (!(event.data && event.data.toLowerCase().indexOf('playerfinished') >= 0))
                        return;
                    break;
                case 'exercise-edumatic':
                case 'exercise-assessmentq':
                    if (!(event.data && event.data.toLowerCase().indexOf('sessionfinished') >= 0))
                        return;
                    break;
                default:
                    return;
            }
            if (!playerFinished.current)
                onExerciseFinished();
            playerFinished.current = true;
        };
        window.addEventListener('message', onMessage);
        return () => {
            window.removeEventListener('message', onMessage);
        };
    }, [onExerciseFinished, hostname, medialink]);
    return React.createElement("iframe", { className: styles.iframe, src: exerciseUrl, title: medialink.name });
};

export { ExerciseIframe };
